import { render, staticRenderFns } from "./SiteStatsModalTotals.vue?vue&type=template&id=fc3d8d60&scoped=true&"
import script from "./SiteStatsModalTotals.vue?vue&type=script&lang=js&"
export * from "./SiteStatsModalTotals.vue?vue&type=script&lang=js&"
import style0 from "./SiteStatsModalTotals.vue?vue&type=style&index=0&id=fc3d8d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3d8d60",
  null
  
)

export default component.exports